import { ThemeColor } from '@/enums'
import { useTranslation } from 'react-i18next'
import { Button, Typography } from '../../atoms'
import {
  ButtonsContainer,
  CarrierContainer,
  SectionWrapper,
  SelectedCardBottom,
  SelectedCardTop,
  SelectedStyledCard,
  StyledChecked,
  TitleContainer,
} from './styles'

const useMessages = () => {
  const { t } = useTranslation()

  return {
    remove: t('remove'),
  }
}

interface ListItem {
  icon?: string
  text: string
  value: string | number
}

interface SelectedCardNodeProps {
  text: string
  subtext: string
  listItem: ListItem
  resetText: string
  onDelete: (value: string | number) => void
  onResetClick: (params: { value: string | number; text: string }) => void
  value: string | number
}

export const SelectedCardNode = ({
  text,
  subtext,
  listItem,
  resetText,
  onDelete,
  onResetClick,
  value,
}: SelectedCardNodeProps) => {
  const messages = useMessages()

  return (
    <SelectedStyledCard>
      <SelectedCardTop>
        <TitleContainer>
          <Typography variant="captionB">{text}</Typography>
          <Typography color={ThemeColor.b50} variant="p2Body">
            {subtext}
          </Typography>
        </TitleContainer>
        <StyledChecked />
      </SelectedCardTop>
      <SelectedCardBottom>
        <SectionWrapper>
          <CarrierContainer>
            {listItem.icon && <img alt="option icon" src={listItem.icon} />}
            <Typography color={ThemeColor.b50} variant="captionR">
              {listItem.text}
            </Typography>
          </CarrierContainer>
          <ButtonsContainer>
            <div />
            <Button
              onClick={() => onResetClick({ value, text })}
              size="medium"
              variant="outlined"
            >
              {resetText}
            </Button>
            <Button
              color="danger"
              onClick={() => onDelete(value)}
              size="medium"
              variant="outlined"
            >
              {messages.remove}
            </Button>
          </ButtonsContainer>
        </SectionWrapper>
      </SelectedCardBottom>
    </SelectedStyledCard>
  )
}
